module.exports = __webpack_public_path__ + "static/media/politico_magazine_story_2016_09_were-the-only-plane-in-the-sky-214230_plot.64826cc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/politico_magazine_story_2016_09_were-the-only-plane-in-the-sky-214230_plot.png
// module id = 416
// module chunks = 0